import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import _ from 'lodash';
import moment from 'moment';
import Card from '../../../../../../components/LazyWidgets/Card';
import Modal from '../../../../../../components/LazyWidgets/Modal';
import Table from '../../../../../../components/LazyWidgets/Table';
import Button from '../../../../../../components/LazyWidgets/Button';
import Spinner from '../../../../../../components/LazyWidgets/Spinner';
import EmailWithTooltip from '../../../../../components/EmailTooltip/EmailWithTooltip';
import ProgressBar from '../../../../../../components/LazyWidgets/ProgressBar';
import { RUBRIC_COLORS } from '../../../../reports-constants';
import s from './averageRubricCard.module.css';
import LegendGradient from '../../../../../../components/LegendGradient/LegendGradient';
import { withLaunchUrl } from '../../../../hoc/withLaunchUrl';
import { showModeOptions } from './averageRubricsConstants';
import { getConfigObject } from '../../../../../util/config';

class AverageRubricCard extends Component {
  constructor(props) {
    super(props);

    const sortBy = 'rubricAVG';
    const direction = 'asc';
    const secondSortArgument = 'name';

    this.maxRows = 10;

    const data = _.orderBy(
      this.formatTableData(this.props.data),
      [sortBy, secondSortArgument],
      [direction]
    );
    const { style, tableColumns } = this.tableStyle(
      this.props.data,
      this.props.rubricAssignments
    );
    const { displayButton, showMode, isShowLess } = this.getLowScoringValues(
      data
    );

    this.state = {
      isShowLess,
      showMode,
      nullState:
        props.nullState ||
        !this.props.data ||
        !this.props.data.length ||
        !this.checkAllRubricsScore(this.props.data),
      tableColumns,
      tableData: data,
      tableStyle: style,
      sortBy,
      direction,
      secondSortArgument,
      displayButton,
      cellModal: {
        open: false,
      },
    };

    this.showMoreLess = this.showMoreLess.bind(this);
    this.tableSort = this.tableSort.bind(this);
    this.handleCellModal = this.handleCellModal.bind(this);
    this.getLowScoringValues = this.getLowScoringValues.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data)) {
      if (nextProps.nullState || !this.checkAllRubricsScore(nextProps.data)) {
        this.setState({ nullState: true });
      } else {
        const { sortBy, direction, secondSortArgument } = this.state;
        const data = _.orderBy(
          this.formatTableData(nextProps.data),
          [sortBy, secondSortArgument],
          [direction]
        );
        const {
          displayButton,
          showMode,
          isShowLess,
        } = this.getLowScoringValues(data);
        const { style, tableColumns } = this.tableStyle(
          nextProps.data,
          nextProps.rubricAssignments
        );

        this.setState({
          tableStyle: style,
          tableColumns,
          nullState: !nextProps.data || !nextProps.data.length,
          tableData: data,
          showMode,
          displayButton,
          isShowLess,
        });
      }
    }
    return null;
  }

  getLowScoringValues(data) {
    const lowScoring = _.filter(data, (item) => item.rubricAVG < 0.5);
    let displayButton = false;
    let showMode = showModeOptions.DEFAULT;
    let isShowLess = true;

    if (lowScoring.length > 0) {
      if (
        lowScoring.length === data.length &&
        lowScoring.length > this.maxRows
      ) {
        showMode = showModeOptions.ONLY_LOW_SCORING;
        isShowLess = false;
      }
      displayButton = true;
    } else if (data.length > this.maxRows && !lowScoring.length) {
      displayButton = true;
      showMode = showModeOptions.ONLY_HIGH_SCORING;
    }

    return {
      displayButton,
      showMode,
      isShowLess,
    };
  }

  getModalComponent() {
    return (
      <Modal
        trigger={
          <button className={s.howLink} role="link">
            How is this calculated?
          </button>
        }
      >
        <div className={s.howModal}>
          <Modal.Header>
            <p className={s.howModalHeader}>Average Rubric Scores</p>
          </Modal.Header>
          <Modal.Content className={s.howModalBody}>
            <div>
              <p>
                This report displays the average rubric score for each
                assignment (including{' '}
                {getConfigObject().FF_DRAFT_NUMBER_LABELING
                  ? 'all drafts'
                  : 'drafts and final paper'}
                ) and individual student. You can use this report to easily see
                and track rubric scores over an entire course.
                <br />
                <br />
                Warmer, red colors indicate lower rubric scores. Cooler, green
                colors indicate higher rubric scores.
                <br />
                <br />
                Selecting an individual score will show that student’s average
                rubric score and distribution across all criteria.
                <br />
              </p>
            </div>
          </Modal.Content>
        </div>
      </Modal>
    );
  }

  getCellsModal() {
    const { cellModal } = this.state;

    const getBarChars = () =>
      cellModal.rubrics.map((rubric, index) => (
        <div className={s.modalCell} key={index}>
          <span>{rubric.name}</span>
          <div className={s.ProgressBarContainer}>
            <ProgressBar
              className={s.ProgressBar}
              value={rubric.value * 100}
              color={RUBRIC_COLORS.PROGRESS_BAR}
            />
            <span>{rubric.displayValue}</span>
          </div>
        </div>
      ));
    const partialAssig = _.find(this.props.rubricAssignments, {
      id: cellModal.activityId,
    });

    const assig = partialAssig
      ? {
          course_id: this.props.courseId,
          tool: partialAssig.tool,
          activity_id: partialAssig.activityId,
          id: partialAssig.id,
        }
      : {};

    return (
      <Modal
        open={cellModal.open}
        onClosed={() => this.setState({ cellModal: { open: false } })}
      >
        <div className={s.cellModal}>
          <Modal.Header>
            <div className={s.modalHeader}>
              <p>{`${cellModal.name}: ${cellModal.essay}`}</p>
              <a
                className={s.howCalc}
                tabIndex="0"
                href={this.props.getLaunchUrl({ ...assig, tab: 'reports' })}
              >
                View Assignment
              </a>
            </div>
          </Modal.Header>
          <Modal.Content id="my-modal-id" className={s.modalContent}>
            {cellModal.rubrics && getBarChars()}
          </Modal.Content>
        </div>
      </Modal>
    );
  }

  getNullStateMessage() {
    return (
      <div className={s.nullCard}>
        <h2 className={s.title}> Average Rubric Scores </h2>
        <div className={s.mainMessage}>
          <div className={s.bottomText}>
            <h1>
              {' '}
              It looks like no rubrics have been used to score assignments.
            </h1>
            <p>
              When you use rubrics to score assignments you can see how
              students&#39; scores are changing over time.
            </p>
          </div>
        </div>
      </div>
    );
  }

  getRubricCard() {
    const {
      nullState,
      tableStyle,
      isShowLess,
      tableData,
      tableColumns,
      displayButton,
      showMode,
    } = this.state;
    if (this.props.loading) {
      return (
        <div className={s.cardLoading}>
          <h2 className={s.title}> Average Rubric Scores </h2>
          <div className={s.skillsSpinner}>
            <Spinner />
          </div>
        </div>
      );
    }

    if (nullState) {
      return <div className={s.nullState}>{this.getNullStateMessage()}</div>;
    }
    const checkRubricAVG = _.filter(tableData, (item) => item.rubricAVG < 0.5);
    let dataToShow;
    if (showMode === showModeOptions.ONLY_LOW_SCORING) {
      dataToShow =
        isShowLess && checkRubricAVG.length
          ? checkRubricAVG.slice(0, this.maxRows)
          : checkRubricAVG;
    } else if (showMode === showModeOptions.ONLY_HIGH_SCORING) {
      dataToShow = isShowLess ? tableData.slice(0, this.maxRows) : tableData;
    } else {
      dataToShow =
        isShowLess && checkRubricAVG.length ? checkRubricAVG : tableData;
    }

    const getLegendGRadient = () => (
      <LegendGradient
        colors={[
          RUBRIC_COLORS.CELL_1,
          RUBRIC_COLORS.CELL_3,
          RUBRIC_COLORS.CELL_4,
          RUBRIC_COLORS.CELL_5,
          RUBRIC_COLORS.CELL_6,
          RUBRIC_COLORS.CELL_7,
          RUBRIC_COLORS.CELL_8,
          RUBRIC_COLORS.CELL_9,
        ]}
        height={5}
        labels={{ left: 'Low', right: 'High' }}
      />
    );
    return (
      <div>
        <div className={s.cardHeader}>
          <h2 className={s.title}> Average Rubric Scores </h2>
          <div className={s.LegendGradient}>{getLegendGRadient()}</div>
        </div>
        {this.getModalComponent()}
        <div className={s.LegendGradientMobile}>{getLegendGRadient()}</div>
        {this.getCellsModal()}

        <Table
          className={s.tableCustomStyle}
          data={dataToShow}
          columns={tableColumns}
          styling={tableStyle}
          ruled
          sortable
          autosort={false}
          onSortedChange={this.tableSort}
          sortColumn={this.state.sortBy}
          sortDirection={this.state.direction}
        />
        {displayButton && (
          <div className={s.buttonContainer}>
            <Button theme="secondary" onClick={this.showMoreLess}>
              {isShowLess ? 'Show All Students' : 'Show Fewer Students'}
            </Button>
          </div>
        )}
      </div>
    );
  }

  formatTableData(receivedData) {
    return receivedData.map((e, i) => {
      e.className = `customStyle_${i}`;
      e.assignments.forEach((essay) => {
        e[essay.activityId] = essay.rubric;
        e[`${essay.activityId}-sortingValue`] = essay.rubricValue;
      });
      return e;
    });
  }

  checkAllRubricsScore(data) {
    return (
      data.length !== _.filter(data, (item) => item.rubricAVG === 0).length
    );
  }

  handleCellModal(_e, data, student) {
    this.setState({
      cellModal: {
        open: true,
        name: student,
        activityId: data.activityId,
        essay: data.name,
        rubrics: data.rubrics,
      },
    });
  }

  tableSort(_e, order) {
    this.setState({
      sortBy: order.column,
      direction: order.direction,
      tableData: _.orderBy(
        this.formatTableData(this.props.data),
        [order.column, 'name'],
        [order.direction]
      ),
    });
  }

  tableStyle(dataToStyle, rubricAssignments) {
    const colorizeCell = (cell) => {
      if (cell === null) {
        return RUBRIC_COLORS.NULL;
      }
      if (cell < 0.1) {
        return RUBRIC_COLORS.CELL_1;
      }
      if (cell < 0.2 && cell >= 0.1) {
        return RUBRIC_COLORS.CELL_2;
      }
      if (cell < 0.3 && cell >= 0.2) {
        return RUBRIC_COLORS.CELL_3;
      }
      if (cell < 0.4 && cell >= 0.3) {
        return RUBRIC_COLORS.CELL_4;
      }
      if (cell < 0.5 && cell >= 0.4) {
        return RUBRIC_COLORS.CELL_5;
      }
      if (cell < 0.6 && cell >= 0.5) {
        return RUBRIC_COLORS.CELL_6;
      }
      if (cell < 0.7 && cell >= 0.6) {
        return RUBRIC_COLORS.CELL_7;
      }
      if (cell < 0.8 && cell >= 0.7) {
        return RUBRIC_COLORS.CELL_8;
      }
      if (cell < 0.9 && cell >= 0.8) {
        return RUBRIC_COLORS.CELL_9;
      }
      return RUBRIC_COLORS.CELL_DEFAULT;
    };
    const tableHeaders = [];
    const tableColumns = [
      {
        accessor: 'name',
        Header: 'Name',
        cell: (item) => (
          <div>
            {' '}
            <span>{item.name}</span> <br />
            <EmailWithTooltip email={item.email} />
          </div>
        ),
        alignment: 'right',
      },
    ];
    const style = [];

    dataToStyle.forEach((e, i) => {
      const styleAttr = {};
      styleAttr.row = `customStyle_${i}`;
      styleAttr.cells = [];
      styleAttr.cells.push({
        accessor: 'name',
        backgroundColor: e.rubricAVG < 0.5 ? RUBRIC_COLORS.CELL_NORMALIZE : '',
      });

      rubricAssignments.forEach((assignment) => {
        const essay = _.find(e.assignments, { activityId: assignment.id });

        const cellStyle = () => {
          if (essay && essay.rubricValue) {
            if (essay.rubrics.length) return s.linkeable;
            return s.nonLinkeable;
          }
          return s.undefinedCell;
        };

        const essayObject = {};
        essayObject.dueDate = assignment.dueDate;
        essayObject.name = assignment.name;
        essayObject.id = assignment.id;
        essayObject.sortingValue = essay ? essay.rubricValue : null;
        if (!_.find(tableHeaders, { id: assignment.id })) {
          tableHeaders.push(essayObject);
        }
        styleAttr.cells.push({
          accessor: `${assignment.id}-sortingValue`,
          alignment: 'center',
          backgroundColor: colorizeCell(essayObject.sortingValue),
          className: cellStyle(),
        });
      });
      style.push(styleAttr);
    });
    _.orderBy(tableHeaders, ['dueDate', 'name'], ['asc']).forEach((header) => {
      const dynamicHeader = {};
      dynamicHeader.accessor = `${header.id}-sortingValue`;
      dynamicHeader.Header = header.name;
      dynamicHeader[`${header.id}-sortingValue`] = header.sortingValue;

      dynamicHeader.cell = (item) => {
        if (!item[header.id]) {
          return <div className={s.undefinedCell}>—</div>;
        }
        let assignmentItem = _.last(
          _.filter(item.assignments, { activityId: header.id })
        );
        if (!assignmentItem) {
          assignmentItem = _.find(item.assignments, { activityId: header.id });
        }
        assignmentItem.name = header.name;
        if (!assignmentItem.rubrics.length || item[header.id] === '—') {
          return <div className={s.undefinedCell}>{item[header.id]}</div>;
        }
        return (
          <button
            onClick={(e) => this.handleCellModal(e, assignmentItem, item.name)}
            data-id={item[header.id]}
          >
            {item[header.id]}
          </button>
        );
      };
      dynamicHeader.customHeader = () => (
        <div className={s.dinamicHeader}>
          <div>{header.name}</div>
          <div className={s.dueDate}>
            Due Date: <span>{moment(header.dueDate).format('L')}</span>
          </div>
        </div>
      );
      tableColumns.push(dynamicHeader);
    });

    return { style, tableColumns };
  }

  showMoreLess() {
    this.setState((prevState) => ({ isShowLess: !prevState.isShowLess }));
  }

  render() {
    return (
      <Card id="AverageRubricScores" className={s.tableCard} padding={false}>
        <div className={s.shadowContainer}>{this.getRubricCard()}</div>
      </Card>
    );
  }
}

AverageRubricCard.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.array,
  loading: PropTypes.bool,
  nullState: PropTypes.bool,
  rubricAssignments: PropTypes.array,
  courseId: PropTypes.string,
  getLaunchUrl: PropTypes.func.isRequired,
};

AverageRubricCard.defaultProps = {
  id: '',
  className: '',
  data: [],
  rubricAssignments: [],
};

function mapStateToProps(state) {
  return {
    courseId: state.reports.courseAbstract.id,
  };
}

export default compose(
  connect(mapStateToProps),
  withLaunchUrl
)(AverageRubricCard);
